import { createSlice } from '@reduxjs/toolkit'

const FontSlice=createSlice({
name:"font",
initialState:{
    fontScale:1
},
reducers:{
    increaseScale:(state)=>{
        state.fontScale=state.fontScale<1.2 ? state.fontScale+0.1:1.2
    },
    decreaseScale:(state)=>{
        state.fontScale=state.fontScale>0.8 ? state.fontScale-0.1:0.8
    },
    defaultScale:(state)=>{
        state.fontScale=1
    }
}
})

export const {increaseScale,decreaseScale,defaultScale}=FontSlice.actions
export default FontSlice.reducer